import React, { Component } from 'react';
import isEqual from 'lodash-es/isEqual';

import RegistrationComponent from './RegistrationComponent';
import ResourceTypeRadioButtons from './partials/ResourceTypeRadioButtons';
import { createEmptyRegistration, executeAction, isRegistrationValid } from './registrationHelpers';
import guid from '../../utils/guid';

export default class RegistrationFormTestContainer extends Component {
  state = {
    registration: createEmptyRegistration({
      type: 0,
    }),
    disabled: false,
    showValidation: false,
  };
  doAction = (action, value) => {
    this.setState(({ registration }) => {
      const newValue = executeAction(registration, action, value);
      if (isEqual(newValue, registration)) return {};
      return { registration: newValue };
    });
  };

  render() {
    const { registration, disabled, showValidation } = this.state;
    return (
      <div style={{ border: '1px solid blue', maxWidth: '568px' }} className="form-horizontal">
        <ResourceTypeRadioButtons
          value={registration.type}
          disabled={disabled}
          onChange={value =>
            this.setState(({ registration: reg }) => ({ registration: { ...reg, type: value } }))
          }
        />
        <RegistrationComponent
          registration={registration}
          onAction={this.doAction}
          disabled={disabled}
          showValidation={showValidation}
          options={{}}
          mainTaskId="025e4ba3-f664-eb11-8fed-00155d3a96c4"
        />
        <label>
          <input
            type="checkbox"
            value={disabled}
            onChange={e => this.setState({ disabled: !!e.target.checked })}
          />
          Disabled?
        </label>
        <label>
          <input
            type="checkbox"
            value={showValidation}
            onChange={e => this.setState({ showValidation: !!e.target.checked })}
          />
          ShowValidation?
        </label>
        <div>IsValid? {isRegistrationValid(registration, {}) ? 'Valid' : 'Invalid'}</div>
        <pre> {JSON.stringify(registration, null, '  ')}</pre>
      </div>
    );
  }
}
